import { useCallback, useEffect, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, VirtualizeAutoComplete } from "../../components"

import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem } from "@heroui/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory, getModValue, getModVisiblity, linksUrl } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useSelector } from "react-redux"
import { faCancel, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"


const CreateJournalVoucherEntry = () => {
    const { compCode, isMultipleCompany, compState, startDate, endDate } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.jvEntry)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();


    const { isLoading, data: masterData = [] } = useFetchWithBody({
        url: apiRoute.journalVoucherEntry.entryMasterData,
        queryKey: "getMasterData",
        inputData: {
            comp_code: compCode.join(",")
        }
    })

    const onSuccessJvVouNo = (data) => {

        if (data && data.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                [formField.vouNo]: data[0].newjv_vouno,
            }))
        }
    }

    const { mutate: funGenJvVouNo } = usePost({
        url: apiRoute.journalVoucherEntry.generateJvVouNo,
        queryKey: "GenerateJvVoucherNo",
        onSuccessTasks: onSuccessJvVouNo

    })

    const onSuccessTasks = (data) => {
        navigate(linksUrl.journalVoucherEntry.journalVoucherEntryMaster);
    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.journalVoucherEntry.add_update,
        queryKey: "funAddUpdateJournalVoucher",
        onSuccessTasks
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.journalVoucherEntry.fetchEntryDetail,
        queryKey: "fetchJvDetail",
    });

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
        if (startDate && startDate != "" && startDate != null && endDate && endDate != "" && endDate != null) {
            if (isNewEntry) {
                funGenJvVouNo({
                    data: {
                        comp_code: compCode.join(','),
                        start_date: dayjs(startDate).format("YYYY-MM-DD"),
                        end_date: dayjs(startDate).format("YYYY-MM-DD")
                    }
                })
            }
            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                const { comp_code, trn_no, vou_type } = detailParams
                funGetDetail({
                    data: {
                        comp_code: comp_code,
                        trn_no: trn_no,
                        vou_type: vou_type
                    }
                })
            }
        }
    }, [startDate, endDate])


    const formField = {
        trnNo: "trnNo",
        vouType: "vouType",
        vouNo: "vouNo",
        vouDate: "vouDate",
        billNo: "billNo",
        debitAcId: "debitAcId",
        creditAcId: "creditAcId",
        amount: "amount",
        narration: "narration",
        tradeType: "tradeType",
        lacId: "lacId",
        docNo2: "docNo2",
        narration2: "narration2",
        docType: "docType",
        trnFrom: "trnFrom"

    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.vouDate)
            acc[key] = new Date()
        else if (key == formField.amount || key == formField.trnNo)
            acc[key] = 0
        else if (key == formField.vouType)
            acc[key] = 'V'
        else acc[key] = ""
        return acc
    }, {})


    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    const inputBoxes = {
        Row1: [
            {
                id: formField.vouNo,
                name: formField.vouNo,
                placeholder: "Voucher No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.vouDate,
                name: formField.vouDate,
                placeholder: "Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.billNo,
                name: formField.billNo,
                placeholder: "Bill No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            }
        ],

        Row2: [{
            id: formField.debitAcId,
            name: formField.debitAcId,
            placeholder: "Debit A/C",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData ? masterData : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: true,
        },
        {
            id: formField.creditAcId,
            name: formField.creditAcId,
            placeholder: "Credit A/C",
            type: ENUM_INPUT_TYPE.autocomplete,
            size: "sm",
            label: "",
            data: masterData ? masterData : [],
            itemkey: "Party_Id",
            itemvalue: "Party_Name",
            isrequired: false,
        }
        ],
        Row3: [
            {
                id: formField.amount,
                name: formField.amount,
                placeholder: "Amount",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.narration,
                name: formField.narration,
                placeholder: "Narration",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },


        ],

    }

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })
    }

    const funSetTradeType = (partyId) => {
        let t_tradeType = formData.tradeType

        if (compState && compState?.trim() != "") {
            const tempData = masterData.filter((ele) => ele.Party_Id == partyId)

            if (tempData && tempData?.length > 0) {
                if (tempData[0]?.ADD_6.trim() != "") {
                    if (tempData[0]?.ADD_6.trim().toLowerCase() == compState?.trim().toLowerCase())
                        t_tradeType = "RD"
                    else
                        t_tradeType = "OGS"
                }
                else
                    t_tradeType = "URD"
            }

        }

        return t_tradeType
    }

    const handleAutoCompleteChange = (value, name) => {
        let chkAcName = ""

        if (name == formField.creditAcId)
            chkAcName = formData[formField.debitAcId]
        else if (name == formField.debitAcId)
            chkAcName = formData[formField.creditAcId]
        if (chkAcName != "" && value != "" && chkAcName == value) {
            // if (chkAcName == value) {
            toast.error("Credit and Debit A/c  should not be same", {
                "position": "top-center"
            })
            /// }

        }
        else {
            //console.log(name,value)
            // let t_tradeType = formData.tradeType;
            // if (name == formField.debitAcId) {

            //t_tradeType = funSetTradeType(value)
            //}

            setFormData({
                ...formData,
                [name]: value,

            })
        }

    }

    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.vouNo.trim() == "") {
            newErrors[formField.vouNo] = "Voucher No  required"
        }

        if (formData[formField.debitAcId] == "" || formData[formField.debitAcId] == "0") {
            newErrors[formField.debitAcId] = "Debit A/C  required"
        }

        if (formData[formField.creditAcId] == "" || formData[formField.creditAcId] == "0") {
            newErrors[formField.creditAcId] = "Credit A/C  required"
        }
        if (formData[formField.amount] == "" || formData[formField.amount] == "0") {
            newErrors[formField.amount] = "Amount required"
        }
        if (formData[formField.vouDate] == null || formData[formField.vouDate] == "" || formData[formField.vouDate] == "Invalid Date") {
            newErrors[formField.vouDate] = "Date  required"
        }
        if (formData[formField.narration].trim() == "" || formData[formField.narration] == null) {
            newErrors[formField.narration] = "Narration  required"
        }


        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const handleSubmit = (e) => {
        e.preventDefault()

        const validate_form = validateForm()
        if (validate_form) {
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    vou_type: formData[formField.vouType],
                    trn_no: formData[formField.trnNo],
                    vou_no: formData[formField.vouNo],
                    bill_no: formData[formField.billNo],
                    credit_acid: formData[formField.creditAcId],
                    debit_acid: formData[formField.debitAcId],
                    vou_date: formData[formField.vouDate],
                    amount: formData[formField.amount],
                    narration: formData[formField.narration],
                    trade_type: formData[formField.tradeType],
                    lac_id: formData[formField.lacId],
                    doc_No2: formData[formField.docNo2],
                    narration2: formData[formField.narration2],
                    doc_type: formData[formField.docType],
                    trn_From: formData[formField.trnFrom],
                    login_uid: user.username,
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }
    }

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
            if (detail && detail?.length > 0) {
                setFormData({
                    ...formData,
                    [formField.vouType]: detail[0]?.vou_type ?? "",
                    [formField.trnNo]: detail[0]?.trn_no ?? 0,
                    [formField.vouNo]: detail[0]?.doc_no3 ?? "",
                    [formField.billNo]: detail[0]?.doc_no1 ?? "",
                    [formField.creditAcId]: detail[0]?.pac_id ?? "",
                    [formField.debitAcId]: detail[0]?.ac_id ?? "",
                    [formField.vouDate]: detail[0]?.vou_date ?? null,
                    [formField.amount]: detail[0]?.amount ?? 0,
                    [formField.narration]: detail[0]?.narration1 ?? "",
                    [formField.tradeType]: detail[0]?.trade_type ?? "",
                    [formField.lacId]: detail[0]?.lac_id ?? "",
                    [formField.docNo2]: detail[0]?.doc_no2 ?? "",
                    [formField.narration2]: detail[0]?.narration2 ?? "",
                    [formField.docType]: detail[0]?.doc_type ?? "",
                    [formField.trnFrom]: detail[0]?.trn_from ?? "",

                })
            }
        }

    }, [detail])
    const handleClickPrev = () => {
        navigate(linksUrl.journalVoucherEntry.journalVoucherEntryMaster)
    }

    if (isPending) {
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} Journal Voucher Transaction Entry`}
                breadcrumbs={["Account", "Journal Voucher Entry"]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <div shadow="sm" className="mb-3 w-full">
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        {
                            Object.keys(inputBoxes).map((key, ind) => (
                                <div key={key + ind}>
                                    <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                        {
                                            inputBoxes[key].map((item, indx) =>
                                                item.type == ENUM_INPUT_TYPE.select ? (
                                                    <></>
                                                ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                    <Autocomplete
                                                        size="md"
                                                        name={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        label={item?.placeholder}
                                                        eventResizeFeature={true}
                                                        selectionMode="single"
                                                        showScrollIndicators={true}
                                                        labelPlacement={"outside"}
                                                        placeholder={item.placeholder}
                                                        isRequired={item.isrequired}
                                                        isLoading={isLoading}
                                                        className="max-w-23"
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                        isClearable={false}
                                                        isVirtualized
                                                        readonly={isNewEntry ? false : true}
                                                        defaultItems={
                                                            item.data ? item.data : []
                                                        }
                                                        onSelectionChange={(e) =>
                                                            handleAutoCompleteChange(e, item.name)
                                                        }
                                                        color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                        //onChange={handleFormSelectionChange}
                                                        selectedKey={formData[item.name]}
                                                    >
                                                        {(list) => (
                                                            <AutocompleteItem

                                                                key={list[item.itemkey]}
                                                            >
                                                                {list[item.itemvalue]}
                                                            </AutocompleteItem>
                                                        )}
                                                    </Autocomplete>

                                                ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                    <div className=" w-full flex items-center">
                                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                            <DatePicker
                                                                label={item.placeholder}
                                                                views={["day", "month", "year"]}
                                                                format="DD/MM/YYYY"
                                                                value={
                                                                    formData[item.name]
                                                                        ? dayjs(formData[item.name])
                                                                        : formData[item.name]
                                                                }
                                                                onChange={(newValue) => {
                                                                    setFormData((prev) => {
                                                                        return {
                                                                            ...prev,
                                                                            [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                                dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                        };
                                                                    });
                                                                }}
                                                                //isRequired={item.required}
                                                                className="w-full "
                                                                slotProps={{
                                                                    textField: { size: "small", error: errors[item.name], helperText: errors[item.name], required: true },
                                                                }}
                                                            />
                                                        </LocalizationProvider>
                                                    </div>
                                                ) : (
                                                    <Input
                                                        type={item.type}
                                                        name={item.name}
                                                        id={item.name}
                                                        isInvalid={errors[item.name]}
                                                        errorMessage={errors[item.name]}
                                                        placeholder={item.placeholder}
                                                        label={item.placeholder}
                                                        labelPlacement="outside"
                                                        isRequired={item.isrequired}
                                                        value={formData[item.name]}
                                                        variant="bordered"
                                                        onChange={(e) => handleChange(e)}
                                                        readOnly={item.name == formField.vouNo ? true : false}
                                                        size={"md"}
                                                        classNames={{
                                                            label: "text-xs text-black font-bold",
                                                        }}
                                                    ></Input>
                                                )
                                            )
                                        }
                                    </div>

                                </div>

                            ))
                        }

                        <div className="justify-center flex gap-5 mt-5">
                            <Button
                                color="primary"
                                type="submit"
                                size="md"
                                variant="shadow"
                                tabIndex={-1}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Submit
                            </Button>
                            <Button
                                color="danger"
                                variant="shadow"
                                size="md"
                                tabIndex={-1}
                                onPress={handleClickPrev}
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                            >
                                Cancel
                            </Button>
                        </div>
                    </form>
                </div>
            </MainContainer>
        </div>
    )

}
export default CreateJournalVoucherEntry